import { Component, OnInit } from '@angular/core';

import { environment } from '@env/environment';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-modal',
  providers: [],
  standalone: true,
  templateUrl: './modal.component.html',
  imports: [ButtonModule],
})
export class Modal implements OnInit {
  data: any;
  rejectedCode: number = 0; // arreglar
  country = environment.country;

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit() {
    this.data = this.config.data;
  }

  closeDialog(data: any) {
    this.ref.close(data);
  }
}
